import { cn } from "@/utils/styles";
import { Tooltip } from "react-tooltip";
import type { PlacesType } from "react-tooltip";

type SimpleTooltipType = {
  children: React.ReactNode;
  content: React.ReactNode;
  id: string;
  className?: string;
  place?: PlacesType;
  tooltipClassName?: string;
  openOnClick?: boolean;
  isOpen?: boolean;
  delayHide?: number;
};

export const SimpleTooltip = ({
  children,
  content,
  id,
  className,
  place,
  openOnClick = false,
  isOpen,
  delayHide,
  tooltipClassName = ""
}: SimpleTooltipType) => {
  return (
    <>
      <div
        data-tooltip-id={id}
        data-testid={id}
        data-tooltip-variant="dark"
        className={cn(content ? "cursor-pointer" : "", className)}
      >
        {children}
      </div>
      <Tooltip
        isOpen={isOpen}
        openOnClick={openOnClick}
        delayHide={delayHide}
        opacity={1}
        id={id}
        border={0}
        style={{ fontSize: "12px", zIndex: 999999999 }}
        className={cn(
          "z-10 rounded-[8px] !bg-gray-dark-600 !px-2 !py-1 !text-gray-dark-1000",
          tooltipClassName
        )}
        place={place}
      >
        {content}
      </Tooltip>
    </>
  );
};
